//
import type { FetchOptions, FetchContext } from 'ofetch'

export const useApi = async <T>(url: string, extras:FetchOptions = { method: 'GET' }) => {
  const runtimeConfig = useRuntimeConfig()
  // let apiUrl = runtimeConfig.public.api
  // if (!apiUrl) { apiUrl = window.location.origin + '/api' }
  // ignoro o env, e seto sempre como /api. pois estava dando problema em alguns ambientes
  const apiUrl = window.location.origin + '/api'
  const urlFinal = (url.startsWith('http')) ? url : (apiUrl + url).replace(/[^:]\/\//g, '/')

  return new Promise<T>(async (resolve, reject) => {
    const makeFetch = (url, extras, onErro401 = null) => {
      $fetch<T>(url, extras)
        .then((data) => {
          resolve(data)
        }).catch((e) => {
          if (onErro401 && e.status === 401 && e.data.message === 'Token Expire') { onErro401(e) } else { reject(e) }
        })
    }

    async function ErrorFunc (errorOriginal) {
      try {
        const refreshToken = await $fetch(apiUrl + '/auth/refresh', { method: 'POST' })
        if (refreshToken) {
          makeFetch(urlFinal, extras)
        }
      } catch (e) {
        // console.log('error renovando token')
        reject(errorOriginal)
      }
    }

    makeFetch(urlFinal, extras, ErrorFunc)
  })
}
